import { useSelector } from 'react-redux';
import { getKey } from '../store/translations/selectors';

function useTranslate() {
    const translate = useSelector(getKey);

    return translate;
}

export default useTranslate;